import { render, staticRenderFns } from "./addCalcRule.vue?vue&type=template&id=20eee5fa&scoped=true"
import script from "./addCalcRule.vue?vue&type=script&lang=js"
export * from "./addCalcRule.vue?vue&type=script&lang=js"
import style0 from "./addCalcRule.vue?vue&type=style&index=0&id=20eee5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eee5fa",
  null
  
)

export default component.exports